import BasicPillar from './BasicPillar.jsx'

/**
 * EO Buyouts pillar.
 *
 * Three simple goals (no sub-goals):
 *   • 4 EO buyouts finalized
 *   • 4 transaction announcements
 *   • 85% client satisfaction
 *
 * All per-goal infra (weekly summary, action items, comments, undo,
 * presence, HubSpot-readonly) is inherited via BasicPillar + GoalCard.
 */
export default function EoBuyoutsPillar() {
  return (
    <BasicPillar
      pillarId="eo-buyouts"
      description={
        'Q2 2026 Employee-Owned buyout targets. Progress and weekly summaries live in the same KV store the current dashboard uses.'
      }
    />
  )
}
